
var sprite = require("C:/Users/semi-opaque/Desktop/code/mudutv_web/mobile/assets/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 -2 59.75 60.25\" id=\"loading\" ><path fill=\"#ccc\" d=\"M29.691-.527c-15.648 0-28.333 12.685-28.333 28.333s12.685 28.333 28.333 28.333c15.648 0 28.333-12.685 28.333-28.333S45.339-.527 29.691-.527zm.184 53.75c-14.037 0-25.417-11.379-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.379 25.417 25.417-11.38 25.416-25.417 25.416z\"/><path fill=\"none\" stroke=\"#108ee9\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M56.587 29.766c.369-7.438-1.658-14.699-6.393-19.552\"/></symbol>";
module.exports = sprite.add(image, "loading");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/loading.svg
// module id = 150
// module chunks = 0 1 2 3 4 5 7